import React from 'react';
import PropTypes from 'prop-types';

import { Space, Modal, Button, Tooltip } from 'antd';
import {
  CopyOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  InboxOutlined,
} from '@ant-design/icons';
import { getTranslatedString } from 'helpers/i18n';

const RowActions = ({ rowData, onDelete, onDuplicate, onArchive }) => {
  const { confirm } = Modal;

  const showDeleteModal = () => {
    const handleOk = () => {
      onDelete(rowData, rowData.id);
    };

    confirm({
      title: getTranslatedString('landlordPortal.fees.deleteFeeTemplateTitle'),
      icon: <ExclamationCircleOutlined />,
      content: getTranslatedString('landlordPortal.fees.deleteFeeTemplateDesc'),
      onOk: handleOk,
      okText: getTranslatedString('landlordPortal.fees.delete'),
      mask: true,
      closable: false,
      maskClosable: true,
    });
  };

  const showDuplicateModal = () => {
    const handleOk = () => {
      onDuplicate(rowData.id);
    };

    confirm({
      title: getTranslatedString('landlordPortal.fees.duplicateFeeTemplateTitle'),
      icon: <ExclamationCircleOutlined />,
      content: getTranslatedString('landlordPortal.fees.duplicateFeeTemplateDesc'),
      onOk: handleOk,
      okText: getTranslatedString('landlordPortal.fees.duplicate'),
      mask: true,
      closable: false,
      maskClosable: true,
    });
  };

  const showArchiveModal = () => {
    const handleOk = () => {
      onArchive(rowData, rowData.id);
    };

    confirm({
      title: getTranslatedString('landlordPortal.fees.archiveFeeTemplateTitle'),
      icon: <ExclamationCircleOutlined />,
      content: getTranslatedString('landlordPortal.fees.archiveFeeTemplateFullDesc'),
      onOk: handleOk,
      okText: getTranslatedString('landlordPortal.fees.archive'),
      mask: true,
      closable: false,
      maskClosable: true,
    });
  };

  const renderActions = () => {
    const icons = [];
    if (!!onDuplicate) {
      icons.push(
        <Tooltip title="Duplicate" key="duplicate">
          <Button shape="circle" type="link" onClick={showDuplicateModal} icon={<CopyOutlined />} />
        </Tooltip>
      );
    }
    if (!!onArchive) {
      icons.push(
        <Tooltip title="Archive" key="archive">
          <Button type="link" icon={<InboxOutlined />} onClick={showArchiveModal} />
        </Tooltip>
      );
    }
    if (!!onDelete) {
      icons.push(
        <Tooltip title="Delete" key="delete">
          <Button type="link" icon={<DeleteOutlined />} onClick={showDeleteModal} />
        </Tooltip>
      );
    }

    return icons;
  };

  return (
    <>
      <Space size="small">{renderActions()}</Space>
    </>
  );
};

RowActions.propTypes = {
  onDelete: PropTypes.func,
  onArchive: PropTypes.func,
  onDuplicate: PropTypes.func,
  rowData: PropTypes.object.isRequired,
};

export default RowActions;
